export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RootView.vue?vue&type=template&id=4d14c7d6&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/RootView.vue?vue&type=template&id=4d14c7d6&scoped=true&
// module id = 187
// module chunks = 31